<div class="privacy-statement">
  <div >
    <h2 class="title sm:text-2xl mx:text-4xl">
      <div>博世汽车技术服务（中国）有限公司上海分公司个人信息保护政策</div>
      <div>更新日期：【2024年1月18日】</div>
    </h2>
    <div>
      <p>本《个人信息保护政策》（以下简称“本政策”）阐述了【博世汽车技术服务（中国）有限公司上海分公司】（以下统称为“我们” 或“公司”）如何在您使用我们的【汽车配件信息订购或服务】时处理来自您或者关于您的个人信息，【包括您使用或访问我们的博世智能出行售后经销商门户网站】；以及您接受适用本政策的我们的其他服务（上述统称为“服务”）。</p>
      <p>在我们的业务和提供服务过程中，我们非常注重保护您的个人信息。我们将根据法律规定，收集、使用、存储、传输、共享和保护您的个人信息。个人信息指以电子或者其他方式记录的与已识别或者可识别的您个人有关的各类信息，不包括匿名化处理后的信息。我们的公司政策对数据保护和信息安全有着严格规定。</p>
      <p>请您在使用我们的服务前，仔细阅读本政策，以便您更好地了解我们是如何处理您的个人信息的。</p>
      <p>本政策将帮助您了解以下内容：</p>
      <ul class="list">
        <li>我们如何收集和使用您的个人信息</li>
        <li>我们如何保护您的个人信息</li>
        <li>我们如何存储、跨境传输您的个人信息 </li>
        <li>我们如何共享、转让、公开披露您的个人信息 </li>
        <li>您的权利 </li>
        <li>Cookies和同类技术的使用 </li>
        <li>APP的使用 </li>
        <li>第三方在线服务 </li>
        <li>未成年人保护 </li>
        <li>本政策如何更新 </li>
        <li>如何联系公司 </li>
      </ul>
    </div>
    <div>
    <h3 class="subtitle">1. 我们如何收集和使用您的个人信息 </h3>
    <p>我们会根据合法、正当、必要、透明的原则，基于本政策所述的目的，收集您的个人信息。如果我们将您的个人信息用于本政策未载明的其他用途，或基于其他特定目的而收集您的个人信息，我们将以合理的方式告知您，并再次征得您的同意。 </p>
    <ul class="list">
      <li>
        <p>您须授权给我们处理您的个人信息的情形</p>
        <ul class="list alpha">
          <li><p>账户注册、登录和验证 <br> 为了实现您使用我们产品或服务的基本功能， 您需要注册我们的账户。当您需使用您的电子邮件地址及手机号码+验证码注册博世Single KeyID系统后，即可采用手机号码+验证码的方式或者以邮箱地址+密码方式进行登录。 </p></li>
          <li><p>交易信息 <br> 当您在博世智能出行售后经销商门户订购具体产品及/或服务时，我们将会收集您提交的收货人姓名、收货地址、收货联系人电话，同时保存相关的服务信息 。 </p></li>
          <li><p>产品支持和售后服务 <br> 为了向您提供产品订单查询以及售后服务，保障您的交易安全，我们将会获取您的订单信息以供您后续的查阅。 </p></li>
          <li>
            <p>日志信息 <br> 为了更进一步优化我们的网站，并根据访问者的需求，更好地对网站进行更新。当您使用我们的服务时，包括浏览网站或者使用其他移动数据终端时，我们可能会自动收集相关信息，并储存在日志信息中。 <br> 我们只会在达成本政策所述目的所需的期限内保留您的日志信息。为了预防事故和保障信息安全（例如为了调查网络攻击事件），日志信息需要作为证据继续保存的，在最终澄清相关事件之前，它们不会被删除，在个别情况下可能会被移交调查机构。</p>
            <p>日志信息包括：</p>
            <ul class="list disc">
              <li>您访问在线服务的IP地址 </li>
              <li>您通过哪个网站访问我们（Referrer URL）</li>
              <li>浏览的页面以及搜索信息</li>
              <li>下载的文件以及数量</li>
              <li>访问日期和时间（包括时长） </li>
              <li>传输的数据量 </li>
              <li>操作系统和所使用的互联网浏览器的信息，包括所安装的附加组件（如Flash Player） </li>
              <li>http状态代码（如"重新请求成功 "或 "未找到请求的文件"） </li>
            </ul>
          </li>
        </ul>
        <p>【单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。】 </p>
      </li>
      <li><p>我们从第三方获取的您的个人信息 <br> 您理解并知悉，在法律允许的情况下我们可能从第三方获取您的个人信息。<br> 我们只会在确认第三方已经取得您的授权同意后再从该第三方收集您的个人信息。如果第三方的授权范围无法涵盖我们的处理和使用目的时，我们会自行或者要求该第三方征得您的同意后再行处理您的个人信息。  </p></li>
      <li>
        <p>基于合理和其他必要目的收集获取的您的个人信息 </p>
        <span>在以下情况下，我们可在不取得您同意的情况下收集您的个人信息：</span>
        <ul>
          <li>为了与您订立、履行合同所必需； </li>
          <li>履行法定职责或者法定义务所必需； </li>
          <li>应对突发公共卫生事件，或紧急情况下为保护您或他人的生命健康和财产安全所必需； </li>
          <li>为公共利益实施新闻报道，在合理的范围内处理个人信息； </li>
          <li>在合理的范围内处理您自行公开或者已经合法公开的个人信息； </li>
          <li>法律、行政法规规定的其他情形。 </li>
        </ul>
      </li>
    </ul>
    </div>
    <div>
    <h3 class="subtitle">2. 我们如何保护您的个人信息 </h3>
    <ul>
      <li>
        <p class="mini-title">完善的信息安全管理系统</p>
        <p>我们会采取一切合理可行的措施，保护收集的您的个人信息。公司内部已经实施了【信息安全管理系统（ISMS）,该系统是以ISO27001为标准而制定的】。 </p>
        <p>我们的信息安全管理系统定义了信息分类方法。根据分类，信息在存储和传输时需要加密，而且只允许使用先进的加密方法和去标识化等安全技术措施。同时我们实施了复杂的授权管理方法，其中权限的角色分为标准授权，关键授权或敏感授权。 </p>
        <p>我们将定期对于个人信息保护情况进行合规审计。</p>
      </li>
      <li>
        <p class="mini-title">进行安全评估、记录和保存 </p>
        <span>在以下情形时，我们将事前进行个人信息保护影响评估，并对评估报告和处理情况依法进行记录和保存： </span>
        <ul class="list">
          <li>处理您的敏感个人信息；</li>
          <li>利用个人信息进行自动化决策； </li>
          <li>委托处理个人信息，向第三方提供个人信息，公开个人信息； </li>
          <li>向境外提供个人信息； </li>
          <li>其他对个人权益有重大影响的个人信息处理活动。 </li>
        </ul>
      </li>
      <li>
        <p class="mini-title">安全事件处置 </p>
        <p>我们将尽力确保您个人信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、泄露、篡改、或丢失，我们将立即采取补充措施，并按照法律法规的要求及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。 </p>
        <p>我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们将会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。 </p>
      </li>
    </ul>
    </div>
    <div>
    <h3 class="subtitle">3. 我们如何存储、跨境传输您的个人信息 </h3>
    <ul>
      <li>
        <p class="mini-title">存储地点 </p>
        <p>原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。 </p>
      </li>
      <li>
        <p class="mini-title">跨境传输（需单独同意）</p>
        <p>为了向您提供产品或服务需要将个人信息进行跨境传输时，我们将遵守中国的法律法规规定，依法(i)通过国家网信部门组织的安全评估；或(ii)按照国家网信部门的规定经专业机构进行个人信息保护认证；或(iii)按照国家网信部门制定的标准合同与境外接收方签订合同，约定双方的权利和义务；或(iv)符合法定的其他条件。 </p>
        <span>我们需要分享您的个人信息给境外的附属和关联公司，以及服务提供商和授权伙伴时，我们将事先获得您的单独同意并告知您个人信息出境的以下相关内容: </span>
        <ul class="list">
          <li>接收方名称/姓名：Robert Bosch(South East Asia)Pte. Ltd. </li>
          <li>接收方的联系方式：<a href="mailto:XiaoYan.Lin@sg.bosch.com">XiaoYan.Lin@sg.bosch.com</a> </li>
          <li>境外处理目的：【仅系统内存储】 </li>
          <li>境外处理方式：【仅系统内存储，不做其他处理】 </li>
          <li>涉及的个人信息种类：【您的姓名、手机号码、邮箱和公司地址信息】 </li>
          <li>个人向境外接收方行使法律规定的权利的方式和程序： </li>
        </ul>
        <span>我们将采取必要措施，保障传输到境外的您的个人信息得到相应等级的保护。 </span>
      </li>
      <li>
        <p class="mini-title">存储期限 </p>
        <p>我们将在您使用我们的服务期间及达成本政策所述目的所需的必要期限内为您保存您的个人信息， 但法律要求或可更长保存期的除外。如果我们收到您申请注销您的注册账户或可验证的您删除个人信息的请求，我们将依据适用的法律法规规定停止使用，并删除您的个人信息或进行匿名化处理。 </p>
      </li>
    </ul>
    </div>
    <div>
    <h3 class="subtitle">4. 我们如何共享、转让、公开披露个人信息 </h3>
    <p class="mini-title">与第三方共享或委托处理</p>
    <ul class="list">
      <li>
        <p>原则上我们不会与任何公司、组织和个人分享您的个人信息，必要时我们可能与以下第三方共享并委托处理您的个人信息： </p>
        <ul class="list disc">
          <li><p>执法部门、监管机构： 依据法律法规的规定、诉讼、仲裁等争议解决需要，或按行政、司法机关依法提出的要求提供给相关机构或团体 ； </p></li>
          <li><p>关联公司：为了更好地向您提供我们的服务和产品以及出于业务运营需要，您的个人信息可能会与我们的关联公司共享。当前我们不会将您的个人信息与其他博世公司共享。当我们需要将您的信息与其它博世公司共享时，我们会及时更新我们的隐私政策并重新获取您的同意。 </p></li>
          <li><p>授权合作伙伴的SDK/API： 为保障我们网页和移动客户端的稳定运行、功能实现，使您能够享受和使用更多的服务及功能，我们可能会嵌入授权合作伙伴的SDK或其他类似的工具。我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息。当前我们未使用合作伙伴的SDK/API。 </p></li>
        </ul>
      </li>
      <li>
        <p>转让 </p>
        <p>我们不会将您的个人信息转让给任何公司、组织和个人，以下情况例外：</p>
        <ul class="list disc">
          <li><p>在获取您的同意授权下，我们会向其他方转让您的个人信息。在此情况下，我们将取得您的单独同意，并告知您接收方的名称/姓名、联系方式、处理目的、处理方式和个人信息的种类。第三方变更对您个人信息的处理目的、处理方式的，将重新取得您的同意； </p></li>
          <li><p>当涉及合并、分立、解散或被宣告破产，公司需要将您的个人信息进行转让时，我们将告知您接收方的名称或者姓名和联系方式，并会要求接收方继续依法履行个人信息处理者的义务，保护您的个人信息安全。接收方变更原先的处理目的、处理方式的，应当依法重新取得您的同意。</p></li>
        </ul>
      </li>
      <li>
        <p>公开披露</p>
        <span>我们仅会在以下情况下，公开披露您的个人信息： </span>
        <ul class="list disc">
          <li><p>出于必要原因并事前获得您的单独同意； </p></li>
          <li><p>基于法律或合理依据的公开披露：包括法律法规规范、法律程序、诉讼或应政府主管部门要求。 </p></li>
        </ul>
      </li>
    </ul>
    </div>
    <div>
    <h3 class="subtitle">5. 您的权利： </h3>
    <p>按照中国相关的法律法规，您对自己的个人信息可以行使以下权利： </p>
    <ul>
      <li>
        <p class="mini-title">查阅、复制、转移您的个人信息 </p>
        <p>您有权查阅、复制您的个人信息，法律法规规定的例外情况除外。如果您想行使您的个人信息查阅权，您可以依照指引，通过登录【我的账户→ 用户信息】获取对您个人信息的查阅，也可以联系我们查阅或复制您的个人信息。 </p>
        <p>如果您请求将您的个人信息转移至您指定的其他个人信息处理者，符合国家网信部门规定条件的，我们将相应提供转移的途径。 </p>
      </li>
      <li>
        <p class="mini-title">更正和补充您的个人信息 </p>
        <p>当您发现我们处理的关于您的个人信息有错误或缺漏时，您有权要求我们做出更正和补充。可以通过本政策提供的联系方式与我们获得联系。 </p>
      </li>
      <li>
        <p class="mini-title">删除您的个人信息 </p>
        <p>在以下情形中，我们将主动删除您的个人信息；您也可以向我们提出删除个人信息的请求： </p>
        <ul class="list">
          <li>如果我们处理您个人信息的目的已实现、无法实现或者实现处理目的不再必要； </li>
          <li>我们停止向您提供服务或者产品或者保存期限已届满； </li>
          <li>您个人撤回我们收集和处理您个人信息的同意的； </li>
          <li>我们违反法律、行政法规或者违反约定处理您的个人信息的； </li>
          <li>如果您注销了您的个人账户； </li>
          <li>法律、行政法规规定的其他情形。 </li>
        </ul>
        <p>在法律、行政法规规定的保存期限未届满，或者删除您的个人信息从技术上难以实现时，我们将停止除储存和采取必要的保护措施之外的处理。 </p>
      </li>
      <li>
        <p class="mini-title">变更您授权同意的范围 </p>
        <p>您可以通过关闭相关功能、解除绑定账号、修改个人设置、删除相关信息等方式撤回部分授权。您也可以通过注销账户的方式，撤回我们继续收集您个人信息的全部授权。 </p>
        <p>请您理解，每个业务功能需要一些基本的个人信息才能得以实现，当您撤回同意或授权后，我们无法继续为您提供撤回同意或授权所对应的服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的同意或授权而开展的个人信息处理。 </p>
      </li>
      <li>
        <p class="mini-title">注销账户 </p>
        <p>您随时可以注销已注册的账户，可以通过本政策提供的联系方式与我们获得联系，以注销您的账户。 </p>
        <p>您注销账户后，我们将停止为您提供产品和/或服务，除法律法规另有规定外，我们将删除您所有的个人信息或对其进行匿名化处理。 </p>
      </li>
      <li>
        <p class="mini-title">响应您的上述请求 </p>
        <p>为保障安全，我们可能会先要求您验证自己的身份（如要求您提供书面请求，或以其他方式证明您的身份），然后再处理您的请求。我们将在15个工作日内做出答复。 </p>
        <span>在以下情形中，我们将无法响应您的请求： </span>
        <ul class="list">
          <li>与我们履行法律法规规定的义务相关的； </li>
          <li>与国家安全、国防安全直接相关的； </li>
          <li>与公共安全、公共卫生、重大公共利益直接相关的； </li>
          <li>与刑事犯罪侦查、起诉、审判和执行判决等直接相关的； </li>
          <li>有充分证据表明个人信息主体存在主观恶意或滥用权利的； </li>
          <li>出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的； </li>
          <li>响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的； </li>
          <li>涉及商业秘密的。 </li>
        </ul>
      </li>
    </ul>
    </div>
    <div>
    <h3 class="subtitle">6. Cookies和同类技术的使用 </h3>
    <ul>
      <li>
        <p class="mini-title">我们使用的Cookies </p>
        <p>我们会使用Cookies和活动脚本（例如JavaScript）来追踪访问者的偏好，并相应优化我们的网站。 </p>
        <p>Cookies是您访问我们网站时存储在您计算机内的小型文本文件。如果有需要，您可以随时删除这些cookies，但这可能导致本网站某些功能不可使用。有关如何删除Cookies的信息，请查阅浏览器的帮助功能。 </p>
      </li>
      <li>
        <p class="mini-title">Cookies类别   </p>
        <p>对于在线服务技术功能上必不可少的Cookie及非必要的Cookies和追踪机制之间，我们作出了区分。通常在没有技术用途的情况下，也可以使用没有Cookies的在线服务。 </p>
        <ul class="list">
          <li>
            <p>技术上必要的Cookie </p>
            <p>技术上必要的Cookies是指用于保证在线服务的Cookies。比如，存储数据以确保视频或音频素材流畅再现的Cookies。 </p>
          </li>
          <li>
            <p>技术非上必要的Cookie和追踪机制 </p>
            <p>除了用于存储您当前隐私设置的Cookie (selection cookie)，技术上非必要的Cookies和追踪机制让我们能够为您提供出色的用户体验和定制产品（marketing cookies和追踪机制）。此类Cookie仅在事先征得您同意的情况下才会使用。该Cookie是依照合法权益设置的。 </p>
            <p>通过使用市场营销Cookies和追踪机制，我们和我们的合作伙伴可以根据对您的用户行为的分析与您的兴趣向您展示产品。 </p>
          </li>
          <li>
            <p>统计资料工具 </p>
            <p>通过使用统计工具，我们可以对您的网页浏览量等数据进行统计。 </p>
            <p>转化追踪：如果您通过各自合作伙伴的广告访问我们的网站，我们的转化追踪合作伙伴会将Cookies放置在您的计算机上（“Conversion Cookie”）。通常，这些Cookies的有效期为30天。如果您访问我们网站的某些页面并且Cookies尚未过期，则我们和相关的合作伙伴可以识别出您单击了广告，从而被重新定向到我们的网站。这也可以跨多个设备完成。通过Conversion Cookie获得的信息会被用于编译转化统计数据并记录相应广告点击量与使用转化追踪标签，重定向到网站的用户总数。 </p>
            <p>请注意，使用这些工具可能包括将您的数据转移到中华人民共和国以外的第三方。我们将依法通过安全评估或认证；或与境外接收方签订合同，约定双方的权利和义务；或符合法定的其他条件。我们将保障境外接收方的数据保护不低于境内的同等信息保护水平。 </p>
            <p>有关这方面的更多详细信息，请参阅以下各个工具的描述： </p>
            <p>a) Google Analytics <br> 提供者：USA, CA 94043，Mountain View, 1600 Amphitheatre Parkway，Google Inc. <br><br>
              b）Google Tag Manager<br> 提供者：Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ireland <br><br>
              功能：分析用户行为（页面检索，访问者和访问次数，下载），基于已登录Google用户的跨设备信息，创建匿名用户配置文件（跨设备追踪），使用Google提供的特定目标群组的信息补充匿名用户数据，重新定位，UX测试，转化追踪以及与Google Ads一起重新定位。</p>
            <p> </p>
          </li>
        </ul>
      </li>
    </ul>
    </div>
    <div>
    <h3 class="subtitle">7. APP的使用 </h3>
    <p>我们暂不提供移动应用程序（APP）的使用。 </p>
    </div>
    <div>
    <h3 class="subtitle">8. 第三方在线服务 </h3>
    <p>我们向您提供的服务可能会包含第三方在线服务的链接。这些其他链接可能在您访问他们时收集您的信息，并根据他们自己的个人信息保护政策处理这些信息。请您注意在访问时仔细阅读他们的个人信息保护政策。 </p>
    </div>
    <div>
    <h3 class="subtitle">9. 未成年人保护 </h3>
    <p>我们重视并依法保护未成年人个人信息的保护。没有父母或其他监护人的同意，未满18周岁的未成年人不得创建自己的主体账户。未满14周岁的儿童未经父母或其他监护人单独同意不得注册和使用我们的服务。 </p>
    <p>经父母或其他监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或其他监护人明确单独同意或者保护未成年人所必要的情况下，收集和处理未成年人个人信息。 </p>
    </div>
    <div>
    <h3 class="subtitle">10. 本政策如何更新</h3>
    <p>因公司业务和经营的变化或适用法律的变化，我们保留不时更新本政策的权利。我们将通过【网站内通知】方式提供经更新的本政策，请您及时查看以获得更新。对本政策的任何更新将在更新版的本政策发布后自更新之日起立即生效。在本政策更新后继续使用本政策项下服务，即表示您确认已阅读并理解更新后的政策。 </p>
    <p>本政策首页会显示最近一次更新的日期。对于重大变更，我们会向您就该重大变更提供适当通知。 </p>
    <p>本政策所指的重大变更包括但不限于： </p>
    <ul class="list">
      <li>处理个人信息的目的、处理的个人信息类型、个人信息的使用方式发生变化；</li>
      <li>个人信息共享、转让或公开披露的主要对象发生变化； </li>
      <li>您参与个人信息处理方面的权利及其行使方式发生重大变化； </li>
      <li>我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时； </li>
      <li>个人信息安全影响评估报告表明存在高风险时。 </li>
    </ul>
    <p>只有在获取您的同意后，我们才会按照更新后的本政策处理您的个人信息。 </p>
    </div>
    <div>
    <h3 class="subtitle">11. 如何联系公司 </h3>
    <p>如果您对本政策有任何疑问、意见或建议，请通过以下方式与公司的信息收集方或数据安全管理部门联系，公司一般将在15个工作日内予以反馈。 </p>
    <p>联系方式如下： </p>
    <p>信息收集及处理方联系方式： </p>
    <p>电子邮件： <a href="mailto:ccc@cn.bosch.com">ccc@cn.bosch.com</a> </p>
    <p>电话：<a href="tel:4000005109">400-000-5109</a> </p>
    <p>数据安全部门联系方式： </p>
    <p>电子邮件：<a href="mailto:China.DPO@cn.bosch.com">China.DPO@cn.bosch.com</a> </p>
    </div>
  </div>
</div>
